import { toggleRowStatus, getKeysMap, getRowIdentity } from '../util';
export default {
  data: function data() {
    return {
      states: {
        defaultExpandAll: false,
        expandRows: []
      }
    };
  },
  methods: {
    updateExpandRows: function updateExpandRows() {
      var _this$states = this.states,
        _this$states$data = _this$states.data,
        data = _this$states$data === void 0 ? [] : _this$states$data,
        rowKey = _this$states.rowKey,
        defaultExpandAll = _this$states.defaultExpandAll,
        expandRows = _this$states.expandRows;
      if (defaultExpandAll) {
        this.states.expandRows = data.slice();
      } else if (rowKey) {
        // TODO：这里的代码可以优化
        var expandRowsMap = getKeysMap(expandRows, rowKey);
        this.states.expandRows = data.reduce(function (prev, row) {
          var rowId = getRowIdentity(row, rowKey);
          var rowInfo = expandRowsMap[rowId];
          if (rowInfo) {
            prev.push(row);
          }
          return prev;
        }, []);
      } else {
        this.states.expandRows = [];
      }
    },
    toggleRowExpansion: function toggleRowExpansion(row, expanded) {
      var changed = toggleRowStatus(this.states.expandRows, row, expanded);
      if (changed) {
        this.table.$emit('expand-change', row, this.states.expandRows.slice());
        this.scheduleLayout();
      }
    },
    setExpandRowKeys: function setExpandRowKeys(rowKeys) {
      this.assertRowKey();
      // TODO：这里的代码可以优化
      var _this$states2 = this.states,
        data = _this$states2.data,
        rowKey = _this$states2.rowKey;
      var keysMap = getKeysMap(data, rowKey);
      this.states.expandRows = rowKeys.reduce(function (prev, cur) {
        var info = keysMap[cur];
        if (info) {
          prev.push(info.row);
        }
        return prev;
      }, []);
    },
    isRowExpanded: function isRowExpanded(row) {
      var _this$states3 = this.states,
        _this$states3$expandR = _this$states3.expandRows,
        expandRows = _this$states3$expandR === void 0 ? [] : _this$states3$expandR,
        rowKey = _this$states3.rowKey;
      if (rowKey) {
        var expandMap = getKeysMap(expandRows, rowKey);
        return !!expandMap[getRowIdentity(row, rowKey)];
      }
      return expandRows.indexOf(row) !== -1;
    }
  }
};